import { ERROR } from '../attrs/status';

export const MACHINE_NOT_FOUND = 'machine_not_found';

export const isMachineNotFound = (loadingState: { status?: string; message?: string | number | null }) =>
  loadingState.status === ERROR && loadingState.message === MACHINE_NOT_FOUND;
